import { nextTick, defineAsyncComponent } from "vue";
import { createRouter, createWebHashHistory } from "vue-router";
import { check, checkRoute, goto, loadMap, testRoute } from './RouterPath'
import { usePermissions } from '../store/Permissions'
import MenuApi from '../view/menu/api';
import axios from "axios";
import { ElMessage, ElMessageBox } from "element-plus";
import { addURLParams, getUrlParams } from "../tools/URLTools";
import RemoteCenter from "../remoteservice/RemoteCenter";
import navConfig, { getPermissioNavConfig, whiteName } from "./RouterMap";
import { useTokenStore } from "../store/TokenStore";
import DataPermissionManager from '../datapermission/DataPermissionManager'
import PermissionManager from '../permission/PermissionManage';

let routes = [{
    path: '/',
    name: 'Home',
    component: () => import('../top/Home.vue'),
    children: [
        {
            path: '/editor',
            name: 'menu',
            component: () => import('../view/Editor/edit.vue'),
        },
        {
            path: '/bookPreview',
            name: "BookPreievw",
            component: () => import('../view/Editor/preview.vue'),

        },
        {
            path: '/system/systemuser/menu',
            name: 'menu',
            component: () => import('../view/menu/list/index.vue'),
        },

        {
            path: '/evaluation/create',
            name: 'view',
            component: () =>
                import('../view/evaluation/create.vue'),
        },
        {
            path: '/evaluation/edit',
            name: 'view',
            component: () =>
                import('../view/evaluation/edit.vue'),
        },
        {
            path: '/do/create',
            name: 'do',
            component: () =>
                import('../view/do/create.vue'),
        },
        {
            path: '/do/edit',
            name: 'do',
            component: () =>
                import('../view/do/edit.vue'),
        },
        {
            path: '/system/permission/role',
            name: 'role',
            component: () =>
                import('../view/permission/list/index.vue'),
        },
        {
            path: '/system/systemuser/role',
            name: 'role',
            component: () =>
                import('../view/role/list/index.vue'),
        },

        {
            path: '/simulator/SimulatorCreate',
            name: 'role',
            component: () =>
                import('../view/simulator/SimulatorCreate.vue'),
        },
        {
            path: '/simulator/SimulatorEdit',
            name: 'SimulatorEdit',
            component: () =>
                import('../view/simulator/SimulatorEdit.vue'),
        },
        {
            path: '/system/role-auth/user',
            component: () =>
                import('../view/role/list/authUser.vue'),
            name: 'AuthUser',
        },
        {
            path: '/evaluation/start',
            name: 'view',
            component: () =>
                import('../view/do/start.vue'),
        },
        {
            path: '/score/index',
            name: 'score',
            component: () =>
                import('../view/score/index.vue'),
        },
        {
            path: '/abilities/custom',
            name: 'customAbilities',
            component: () =>
                import('../view/ability/custom.vue'),
        }
    ]
},
{
    path: '/pageHome',
    name: 'page',
    component: () => import('../top/PageHome.vue'),
    children: [
        {
            path: '/tatweb/home',
            name: 'Home',
            component: () =>
                import('../reception/home/home.vue'),
            parent: 'page'
        },
        {
            path: '/tatweb/aboutUs',
            name: 'AboutUs',
            component: () =>
                import('../reception/aboutUs/aboutUs.vue'),
            parent: 'page'
        },
        {
            path: '/tatweb/ask',
            name: 'Ask',
            component: () =>
                import('../reception/ask/ask.vue'),
            parent: 'page',
            meta: {
                page: [
                    {
                        name: '考核资讯'
                    }
                ]
            }
        },
        {
            path: '/tatweb/honorList',
            name: 'honorList',
            component: () =>
                import('../reception/honor/ask.vue'),
            parent: 'page',
            meta: {
                page: [
                    {
                        name: '光荣榜'
                    }
                ]
            }
        },
        {
            path: '/tatweb/certificateQuery',
            name: 'CertificateQuery',
            component: () =>
                import('../reception/certificateQuery/certificateDetail.vue'),
            parent: 'page',
            meta: {
                page: [
                    {
                        name: '证书查询'
                    }
                ]
            }
        },
        {
            path: '/certificate',
            name: 'Certificate',
            component: () =>
                import('../reception/Certificate.vue'),
            parent: 'page'
        },
        {
            path: '/tatweb/course',
            name: 'Course',
            component: () =>
                import('../reception/Course.vue'),
            parent: 'page'
        },
        {
            path: '/tatweb/Controller',
            name: 'Course',
            component: () =>
                import('../reception/Controller.vue'),
            parent: 'page'
        },
        {
            path: '/tatweb/controller/index',
            name: 'Controller',
            component: () =>
                import('../reception/controller/index.vue'),
            parent: 'page',
            meta: {
                page: [
                    {
                        name: '管理员中心'
                    },
                    {
                        name: '用户管理'
                    }
                ]
            }
        },
        {
            path: '/tatweb/controller/report',
            name: 'Controller',
            component: () =>
                import('../reception/controller/report.vue'),
            parent: 'page',
            meta: {
                page: [
                    {
                        name: '管理员中心'
                    },
                    {
                        name: '考核统计'
                    }
                ]
            }
        },
        {
            path: '/tatweb/controller/cooperation',
            name: 'Controller',
            component: () =>
                import('../reception/controller/cooperation.vue'),
            parent: 'page',
            meta: {
                page: [
                    {
                        name: '管理员中心'
                    },
                    {
                        name: '协作申请'
                    }
                ]
            }
        },
        
        {
            path: '/tatweb/personal',
            name: 'Personal',
            component: () =>
                import('../reception/Personal.vue'),
            parent: 'page'
        },
        {
            path: '/explain',
            name: 'Explain',
            component: () =>
                import('../reception/explain.vue'),
            parent: 'page'
        },
        {
            path: '/tatweb/postCourse',
            name: 'PostCourse',
            component: () =>
                import('../reception/post/PostCourse.vue'),
            parent: 'page',
            meta: {
                page: [
                    
                    {
                        name: '备考资料'
                    }
                ]
            }
        },
        {
            path: '/tatweb/BehalPay',
            name: 'PostCourse',
            component: () =>
                import('../view/sale-mobile/BehalPay.vue'),
            parent: 'page',
            meta: {
                page: [
            
                ]
            }
        },
        {
            path: '/tatweb/postDetail',
            name: 'PostDetail',
            component: () =>
                import('../reception/post/PostDetail.vue'),
            parent: 'page'
        },
        {
            path: '/tatweb/post',
            name: 'Post',
            component: () =>
                import('../reception/Post.vue'),
            parent: 'page',
            meta: {
                page: [
                    {
                        name: '岗位胜任力'
                    }
                ]
            }
        },
        {
            path: '/tatweb/introduce',
            name: 'Introduce',
            component: () =>
                import('../reception/introduce.vue'),
            parent: 'page'
        },
        {
            path: '/probation',
            name: 'Probation',
            component: () =>
                import('../reception/Probation.vue'),
            parent: 'page'
        },
        {
            path: '/tatweb/bookRead',
            name: 'BookRead',
            component: () =>
                import('../reception/Reading.vue'),
            parent: 'page'
        },
        {
            path: '/tatweb/guidanceDetail',
            name: 'GuidanceDetail',
            component: () =>
                import('../reception/ask/guidanceDetail.vue'),
            parent: 'page',
            meta: {
                page: [
                    {
                        name: '考核资讯',
                        url:'/tatweb/ask'
                    },
                    {
                        name: '资讯详情'
                    }
                ]
            },
        },
        {
            path: '/tatweb/honorDetail',
            name: 'GuidanceDetail',
            component: () =>
                import('../reception/honor/guidanceDetail.vue'),
            parent: 'page',
            meta: {
                page: [
                    {
                        name: '光荣榜',
                        url:'/tatweb/honorList'
                    },
                    {
                        name: '光荣榜详情'
                    }
                ]
            },
        },
        {
            path: '/page/ebook',
            name: 'Ebook',
            component: () =>
                import('../view/page/ebook.vue'),
            parent: 'page'
        },
        {
            path: '/pdfviewer',
            name: 'Pdfviewer',
            component: () =>
                import('../components/pdfviewer/viewer.vue'),
            parent: 'page'
        },
        {
            path: '/tatweb/apply/index',
            name: 'ApplyEntry',
            component: () => import('../view/apply/ApplyEntry.vue'),
            parent: 'page'
        },
        {
            path: '/tatweb/flow',
            name: 'ExamFlow',
            component: () => import('../reception/exam/ExamFlow.vue'),
            parent: 'page'
        },
        {
            path: '/tatweb/goods/info',
            name: 'goodsInfo',
            component: ()=> import('../view/sale-mobile/SaleGoods.vue'),
            parent: 'page'
        },
        {
            path: '/tatweb/goods/detail',
            name: 'goodsInfo',
            component: ()=> import('../view/sale-mobile/SaleGood.vue'),
            parent: 'page'
        },
        // 购买完成页
        {
            path: '/tatweb/goods/saleDone',
            name: 'saleDone',
            component: ()=> import('../view/sale-mobile/saleDone.vue'),
            parent: 'page'
        }, 
        {
            path: '/tatweb/apply/form',
            name: 'ApplyForm',
            component: () => import('../view/apply/ApplyForm.vue'),
            parent: 'page'
        },
        // 报名成功页
        {
            path: '/tatweb/apply/success',
            name: 'ApplySuccess',
            component: ()=> import('../view/apply/ApplySuccess.vue'),
            parent: 'page'
        }, 
        {
            path: '/tatweb/personal/index',
            name: 'PersonalIndex',
            meta: {
                page: [
                    {
                        name: '个人中心'
                    },
                    {
                        name: '基本信息'
                    }
                ]
            },
            component: () => import('../reception/personal/index.vue'),
            parent: 'page'
        }
        , {
            path: '/tatweb/personal/myCourse',
            name: 'MyCourse',
            component: () => import('../reception/personal/myCourse.vue'),
            parent: 'page',
            meta: {
                page: [
                    {
                        name: '个人中心'
                    },
                    {
                        name: '我的课程'
                    }
                ]
            },
        }
        , 
        {
            path: '/tatweb/personal/expertReview',
            name: 'expertReview',
            component: () => import('../reception/personal/expertReview.vue'),
            parent: 'page',
            meta: {
                page: [
                    {
                        name: '个人中心'
                    },
                    {
                        name: '专家点评'
                    }
                ]
            },
        },
        {
            path: '/tatweb/personal/collect',
            name: 'Collect',
            component: () => import('../reception/personal/collect.vue'),
            parent: 'page',
            meta: {
                page: [
                    {
                        name: '个人中心'
                    },
                    {
                        name: '我的收藏'
                    }
                ]
            },
        }
        , {
            path: '/tatweb/personal/certificate',
            name: 'Collect',
            component: () => import('../reception/personal/certificate.vue'),
            parent: 'page',
            meta: {
                page: [
                    {
                        name: '个人中心'
                    },
                    {
                        name: '我的证书'
                    }
                ]
            },
        }
        , {
            path: '/tatweb/personal/myOrder',
            name: 'MyOrder',
            component: () => import('../reception/personal/myOrder.vue'),
            parent: 'page',
            meta: {
                page: [
                    {
                        name: '个人中心'
                    },
                    {
                        name: '我的订单'
                    }
                ]
            },
        }
        , {
            path: '/tatweb/personal/downloadCenter',
            name: 'DownloadCenter',
            component: () => import('../reception/personal/downloadCenter.vue'),
            parent: 'page',
            meta: {
                page: [
                    {
                        name: '个人中心'
                    },
                    {
                        name: '下载中心'
                    }
                ]
            },
        }
        , {
            path: '/tatweb/personal/Common',
            name: 'Common',
            component: () => import('../reception/personal/Common.vue'),
            parent: 'page',
            meta: {
                page: [
                    {
                        name: '个人中心'
                    },
                    {
                        name: '资料下载'
                    }
                ]
            },
        },
         {
            path: '/tatweb/personal/analysis',
            name: 'analysis',
            component: () => import('../reception/personal/analysis.vue'),
            parent: 'page',
            meta: {
                page: [
                    {
                        name: '个人中心'
                    },
                    {
                        name: '考核分析报告'
                    }
                ]
            },
        },
        {
            path: '/tatweb/personal/expert',
            name: 'expert',
            component: () => import('../reception/personal/expert.vue'),
            parent: 'page',
            meta: {
                page: [
                    {
                        name: '个人中心'
                    },
                    {
                        name: '专家点评分析报告'
                    }
                ]
            },
        },
        {
            path: '/tatweb/personal/examine',
            name: 'Examine',
            component: () => import('../reception/personal/examine.vue'),
            parent: 'page',
            meta: {
                page: [
                    {
                        name: '个人中心'
                    },
                    {
                        name: '我的考核'
                    }
                ]
            }
        },
        {
            path: '/tatweb/personal/message',
            name: 'Message',
            component: () => import('../reception/personal/message.vue'),
            parent: 'page',
            meta: {
                page: [
                    {
                        name: '个人中心'
                    },
                    {
                        name: '我的消息'
                    }
                ]
            }
        }
    ]
},
{
    path: '/customHome',
    name: 'custom',
    component: () => import('../top/CustomHome.vue'),
    children: [
        {
            path: '/tatweb/loginroom',
            name: 'LoginRoom',
            component: () => import('../reception/loginRoom/loginRoom.vue'),
            parent: 'custom'
        },
        {
            path: '/tatweb/loginformalroom',
            name: 'Loginformalroom',
            component: () => import('../reception/loginRoom/loginformalRoom.vue'),
            parent: 'custom'
        },
        {
            path: '/tatweb/assessCountform',
            name: 'AssessCountform',
            component: () => import('../reception/assessCountdown/assessCountform.vue'),
            parent: 'custom'
        },
        {
            path: '/tatweb/exam',
            name: 'Exam',
            component: () => import('../view/do/practice.vue'),
            parent: 'custom'
        },
        {
            path: '/tatweb/exam2',
            name: 'Exam2',
            component: () => import('../view/do/practice2.vue'),
            parent: 'custom'
        },
        {
            path: '/tatweb/history',
            name: 'history',
            component: () => import('../view/do/history.vue'),
            parent: 'custom'
        },
        {
            path: '/tatweb/examTest',
            name: 'examTest',
            component: () => import('../view/do/examTest.vue'),
            parent: 'custom'
        },
        {
            path: '/tatweb/help',
            name: 'help',
            component: () => import('../view/do/help.vue'),
            parent: 'custom'
        }
        ,
        {
            path: '/tatweb/beforeExam',
            name: 'Questionnaire',
            component: () => import('../view/do/beforeExam.vue'),
            parent: 'custom'
        } , 
        {
            path: '/tatweb/questionnaire',
            name: 'Questionnaire',
            component: () => import('../view/do/questionnaire.vue'),
            parent: 'custom'
        } , {
            path: '/tatweb/examResult',
            name: 'ExamResult',
            component: () => import('../reception/examAnalysis/ExamResult.vue'),
            parent: 'custom'
        }
        , {
            path: '/tatweb/imitateReslut',
            name: 'imitateReslut',
            component: () => import('../view/do/imitateReslut.vue'),
            parent: 'custom'
        }, {
            path: '/tatweb/formalResult',
            name: 'formalResult',
            component: () => import('../view/do/formalResult.vue'),
            parent: 'custom'
        }, {
            path: '/tatweb/testResult',
            name: 'testResult',
            component: () => import('../view/do/testResult.vue'),
            parent: 'custom'
        }
    ]
},
// {
//     path: '/login',
//     name: 'Login',
//     component: defineAsyncComponent(() => import('../login/Login.vue')),
// },

{
    path: '/test',
    name: 'test',
    component: defineAsyncComponent(() =>
        import('../test/test.vue')),
},
{
    path: '/test2',
    name: 'test2',
    component: defineAsyncComponent(() =>
        import('../test/test2.vue')),
},
{
    path: '/test3',
    name: 'test3',
    component: () =>
        import('../test/test3.vue'),
},
{
    path: '/test4',
    name: 'test4',
    component: defineAsyncComponent(() =>
        import('../test/test4.vue')),
},
// {
//     path: '/test5',
//     name: 'test5',
//     component: defineAsyncComponent(() =>
//         import('../test/test5.vue')),
// },
{
    path: '/testtree',
    name: 'testtree',
    component: defineAsyncComponent(() =>
        import('../test/testtree.vue')),
},
];
const localRoutes = [{
    path: '/',
    name: 'Home',
    component: () =>
        import('../top/Home.vue'),
},
{
    path: '/customHome',
    name: 'custom',
    component: () =>
        import('../top/CustomHome.vue'),
}, {
    path: '/pageHome',
    name: 'page',
    component: () =>
        import('../top/PageHome.vue'),
}
]
// routes[0].children=routes[0].children.concat(routeMap)
const router = createRouter({
    history: createWebHashHistory(),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { top: 0 }
        }
    },
    // @ts-ignore
    routes: localRoutes,
});

await loadMap(router, routes);
const url = window.location.href;
const query = getUrlParams(url);
checkRoute(url.replace(/^.*\#/, '').replace(/\?.*$/, ''), query);
const whiterName = ['/tatweb/postCourse', '/tatweb/post', '/tatweb/postDetail', 'test5', '/tatweb/apply/index', '/tatweb/apply/form', '/tatweb/aboutUs']
router.beforeEach(async (to, from, next) => {
    // const path = to.path;
    // console.log(path);
    // if (path == '/home') next();
    // else if (!testRoute(to.path)) {
    //     // goto(to.path, to.query)
    //     const Permissions = usePermissions();
    //     const tokenStore = useTokenStore();
    //     if (!tokenStore.token) {
    //         const us = localStorage.getItem('user-info');
    //         if (!us) {
    //             ElMessageBox.alert('登录已过期，请重新登录', '提示：', {
    //                 // if you want to disable its autofocus
    //                 // autofocus: false,
    //                 confirmButtonText: '确定',
    //                 callback: (action) => {
    //                     axios.get('/configs/login.json').then(res => {
    //                         // console.log(res.data)
    //                         window.location.href = res.data.loginAddress
    //                     }).catch((e) => {
    //                         window.location.href = '/login.html';
    //                     })
    //                 },
    //             })
    //             return;
    //         }
    //         const token = JSON.parse(us).token;
    //         tokenStore.setToken(token);
    //         let userInfo = sessionStorage.getItem('user-info');
    //         if (!userInfo) {
    //             userInfo = { token }; //JSON.parse(userInfo);
    //             const data = await RemoteCenter.getUserInfo();
    //             userInfo['userId'] = data.user.userId;
    //             userInfo['userName'] = data.user.userName;
    //             userInfo['roles'] = data?.user?.roles
    //             userInfo['scope'] = data.user.scope
    //             tokenStore.setUserInfo(userInfo);
    //             sessionStorage.setItem('user-info', JSON.stringify(userInfo));
    //             // chatStore.reloadChats();
    //             let dataScope = {
    //                 dataScope: data.user.roles[0].dataScope,
    //                 roleScope: data.roleScope.map(it => {
    //                     return {
    //                         entity: it.entityCode,
    //                         bizTypeCode: it.bizTypeCode,
    //                         readOnly: it.readOnly
    //                     }
    //                 })
    //             }
    //             Permissions.setDataScope(dataScope)
    //             // console.log(Permissions.dataScope)
    //             if (dataScope.dataScope != '1') DataPermissionManager.updatePermissions(dataScope.roleScope)
    //         } else {
    //             userInfo = JSON.parse(userInfo);
    //             userInfo.token = token;
    //             tokenStore.setUserInfo(userInfo);
    //         }

    //         tokenStore.setUserInfo(userInfo);

    //         // MenuApi.getPermission().then(response => {
    //         //     PermissionManager.updatePermissions(response.data);
    //         //     if (to.path == '/') {
    //         //           console.log(PermissionManager.getApplicationAdress())
    //         //           goto(PermissionManager.getApplicationAdress())
    //         //         // if (!PermissionManager.resetNavigator(navConfig)[0].children) {
    //         //         //     goto(PermissionManager.resetNavigator(navConfig)[0].path, to.query)
    //         //         // } else {
    //         //         //     goto(PermissionManager.resetNavigator(navConfig)[0].children[0].path, to.query)
    //         //         // }
    //         //         // goto(navConfig[0].path, to.query)
    //         //     } else {
    //         //         goto(to.path, to.query)
    //         //     }
    //         // })
    //         MenuApi.listMenu({
    //             menuName: '',
    //         }).then(response => {
    //             // PermissionManager.updatePermissions(response.data);

    //             // Permissions.setPermissions(response.data)
    //             // 
    //             // console.log(Permissions.Permissions)
    //         });
    //         goto(to.path, to.query)
    //     } else {
    //         if (to.path == '/') {
    //             goto(PermissionManager.getApplicationAdress())
    //         } else {
    //             goto(to.path, to.query)
    //         }
    //     }
    //     next(false);
    // }
    // else next();
    const Permissions = usePermissions();
    const tokenStore = useTokenStore()
    const path = to.path;
    console.log(path);
   if (path == '/tatweb/course') {
        ElMessage.success("泌乳核心课程即将上线，敬请期待！");
        // ElMessageBox.alert('没有相关信息', '提示：');
        next(false);
        return
    } else { }
    if (path == '/home' || whiteName.includes(path)) {
        try {
            if (!tokenStore.token) {
                const us = sessionStorage.getItem('user-info');
                const u = JSON.parse(us);
                tokenStore.setToken(u.token);
                if (u.userId) {
                    const userInfo = { token: u.token }
                    userInfo['userId'] = u.user.userId;
                    userInfo['userName'] = u.user.userName;
                    userInfo['nickName'] = u.user.nickName;
                    userInfo['roles'] = u?.user?.roles;
                    userInfo['scope'] = u.user.scope;
                    userInfo['userDept'] = u.userDept;
                    userInfo['user'] = u.user;
                    tokenStore.setUserInfo(userInfo);
                }
            }
        } catch {

        }

        next();
    } else if (document.title == '爱婴医院妇幼保健人员岗位胜任力培训与考核' && path == '/') {
        goto('/tatweb/home')
    }
    else if (!testRoute(to.path) || !tokenStore.token) {
        try {
            if (!tokenStore.token) {
                const us = localStorage.getItem('user-info');
                if (!us) {
                    console.log(window.location.hash)
                    ElMessageBox.confirm('请登录后再访问该页面', '温馨提示：', {
                        // if you want to disable its autofocus
                        // autofocus: false,
                        confirmButtonText: '确定',

                    }).then(() => {
                        localStorage.clear()
                        sessionStorage.clear()
                        tokenStore.setUserInfo(null);
                        if (window.location.hash.indexOf('tatweb') != -1) {
                            window.location.href = window.location.origin + '/login-manager.html'
                        } else {
                            window.location.href = window.location.origin + '/login.html'
                        }
                    }).catch(() => {

                    })
                    return;
                }
                const token = JSON.parse(us).token;
                tokenStore.setToken(token);
                let userInfo = sessionStorage.getItem('user-info');
                if (!userInfo) {
                    userInfo = { token }; //JSON.parse(userInfo);
                    const data = await RemoteCenter.getUserInfo();
                    userInfo['userId'] = data.user.userId;
                    userInfo['userName'] = data.user.userName;
                    userInfo['nickName'] = data.user.nickName;

                    userInfo['roles'] = data?.user?.roles;
                    userInfo['scope'] = data.user.scope;
                    userInfo['userDept'] = data.userDept;
                    userInfo['user'] = data.user;
                    tokenStore.setUserInfo(userInfo);
                    sessionStorage.setItem('user-info', JSON.stringify(userInfo));

                    // chatStore.reloadChats();
                    let dataScope = {
                        dataScope: data.user.roles[0].dataScope,
                        roleScope: data.roleScope.map(it => {
                            return {
                                entity: it.entityCode,
                                bizTypeCode: it.bizTypeCode,
                                readOnly: it.readOnly
                            }
                        })
                    }
                    Permissions.setDataScope(dataScope)
                    // console.log(Permissions.dataScope)
                    if (dataScope.dataScope != '1') DataPermissionManager.updatePermissions(dataScope.roleScope)
                } else {
                    userInfo = JSON.parse(userInfo);
                    userInfo.token = token;
                    tokenStore.setUserInfo(userInfo);
                }

                tokenStore.setUserInfo(userInfo);

                if (whiteName.includes(path)) {
                    next();
                    return;
                }

                MenuApi.getPermission().then(response => {
                    PermissionManager.updatePermissions(response.data);
                    if (to.path == '/') {
                        console.log(localStorage.getItem('page'))
                        // console.log(PermissionManager.resetNavigator(navConfig))
                        // console.log(PermissionManager.resetNavigator(navConfig)[0].path)
                        //    goto(PermissionManager.resetNavigator(navConfig)[0].children[0].path, to.query)
                        if (localStorage.getItem('page')) {
                            goto(localStorage.getItem('page'))
                            return;
                        }
                        if (!PermissionManager.resetNavigator(navConfig)[0].children) {
                            const query = {};
                            const menu = PermissionManager.resetNavigator(navConfig)[0]
                            if (menu.filter) {
                                const conds = menu.filter.split(/\s*\&\s*/);
                                for (const cond of conds) {
                                    const vs = cond.split(/\s*\=\s*/);
                                    query[vs[0]] = vs[1];
                                }
                            }
                            goto(menu.path, query)
                        } else {
                            const query = {};
                            const menu = PermissionManager.resetNavigator(navConfig)[0].children[0]
                            if (menu.filter) {
                                const conds = menu.filter.split(/\s*\&\s*/);
                                for (const cond of conds) {
                                    const vs = cond.split(/\s*\=\s*/);
                                    query[vs[0]] = vs[1];
                                }
                            }
                            goto(menu.path, query)
                        }
                        // goto(PermissionManager.resetNavigator(navConfig)[0].path, to.query)
                    } else {
                        goto(to.path, to.query)
                    }
                })
                MenuApi.listMenu({
                    menuName: '',
                }).then(response => {
                    // PermissionManager.updatePermissions(response.data);

                    // Permissions.setPermissions(response.data)
                    // 
                    // console.log(Permissions.Permissions)
                });
            } else {
                if (to.path == '/') {
                    console.log(localStorage.getItem('page'))
                    if (localStorage.getItem('page')) {
                        goto(localStorage.getItem('page'))
                    } else {
                        goto(PermissionManager.getApplicationAdress())
                    }
                } else {
                    if (whiteName.includes(path)) {
                        next();
                        return;
                    }
                    next()
                }
            }
            next(false);
        } catch (e) {
            next(false);
        }
    } else next();
});
router.afterEach((to, from) => {
    check(to);
    if (to?.path == '/') return
    // if (to?.path == from?.path) {
    //     nextTick(() => {
    //         router.go(0);
    //     })
    // }
})

export default router